/*
@license
  Gem by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://help.archetypethemes.co/en/articles/206656

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Gem theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
    
    // Header spacing fix for "Logo center, menu below" layout
    // Fallback for browsers that don't support :has() selector
    function applyHeaderSpacingFix() {
      const headerElements = document.querySelectorAll('.header-layout-center-menu-below');
      const mainContent = document.querySelector('.main-content');
      
      if (headerElements.length > 0 && mainContent) {
        // Check if browser supports :has() selector
        const supportsHas = CSS.supports('selector(:has(*))');
        
        if (!supportsHas) {
          // Add spacing class to main content (baseline)
          mainContent.classList.add('header-spacing-fix');
        }
      }
    }

    // New: Precisely offset main content by actual header height
    function updateMainContentOffset() {
      const siteHeader = document.getElementById('SiteHeader');
      const wrapper = document.getElementById('HeaderWrapper');
      const mainContent = document.getElementById('MainContent');
      if (!siteHeader || !wrapper || !mainContent) return;

      const isCenterBelow = siteHeader.classList.contains('header-layout-center-menu-below');
      const isStickyEnabled = siteHeader.dataset.sticky === 'true';
      const isOverlay = siteHeader.dataset.overlay === 'true';

      // Only adjust when this specific layout is active, sticky is on, and not overlaying content
      if (isCenterBelow && isStickyEnabled && !isOverlay) {
        const headerHeight = wrapper.offsetHeight || 0;
        // Apply exact height; inline style overrides CSS fallbacks
        mainContent.style.paddingTop = headerHeight > 0 ? headerHeight + 'px' : '';
      } else {
        // Reset to allow page-specific styles
        mainContent.style.paddingTop = '';
      }
    }
    
    // Apply the baseline fix and then precise adjustment
    applyHeaderSpacingFix();
    updateMainContentOffset();

    // Re-apply on page transitions (for SPA-like behavior)
    document.addEventListener('page:loaded', function() {
      applyHeaderSpacingFix();
      updateMainContentOffset();
    });

    // Recalculate on resize and orientation changes
    window.addEventListener('resize', updateMainContentOffset);
    window.addEventListener('orientationchange', updateMainContentOffset);

    // Also recalc after a short delay to catch late layout shifts
    setTimeout(updateMainContentOffset, 250);
  });
})();
